import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LoginModal from "@/components/LoginModal";
import RequirementModal from "@/components/RequirementModal";
import PostRequirementFAB from "@/components/PostRequirementFAB";

import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import SellProperty from "@/pages/SellProperty";
import LegalServices from "@/pages/LegalServices";
import AuthCallback from "@/pages/AuthCallback";
import AdminDashboard from "@/pages/AdminDashboard";
import BuyerDashboard from "@/pages/BuyerDashboard";
import BrokerDashboard from "@/pages/BrokerDashboard";
import { About, Contact, Privacy, Terms, Disclaimer, RefundPolicy } from "@/pages/Static";
import SEO, { orgJsonLd } from "@/components/SEO";
import ScrollToTop from "@/components/ScrollToTop";
import UserTypeGate from "@/components/UserTypeGate";

import "@/App.css";

function GlobalModals() {
  const { loginPromptOpen, closeLoginPrompt, requirementOpen, closeRequirement } = useAuth();
  return (
    <>
      <LoginModal open={loginPromptOpen} onClose={closeLoginPrompt} />
      <RequirementModal open={requirementOpen} onClose={closeRequirement} />
      <UserTypeGate />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
          <Route path="/sell" element={<SellProperty />} />
          <Route path="/for-brokers" element={<Navigate to="/sell?ref=broker" replace />} />
          <Route path="/legal" element={<LegalServices />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/broker" element={<BrokerDashboard />} />
          <Route path="/dashboard" element={<BuyerDashboard />} />
        </Routes>
      </main>
      <Footer />
      <PostRequirementFAB />
      <GlobalModals />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SEO jsonLd={orgJsonLd} />
          <Toaster position="top-center" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
